<template>
  <div v-if="isLoaded">
    <ConsentPromotion v-if="!isError" :promotion-info="promotionInfo" />
    <Error
      v-else
      :error-title="ERROR_MSG_TITLE_INVALID_USER"
      :error-text="ERROR_MSG_TEXT_INVALID_USER"
    />
  </div>
</template>
<script setup>
  import { ref } from 'vue'
  import { useConsentRenew } from '@/common/use/useConsentRenew'
  import ConsentPromotion from '@/components/consent/ConsentPromotion.vue'
  import Error from '@/views/error/NotFound.vue'
  import {
    ERROR_MSG_TEXT_INVALID_USER,
    ERROR_MSG_TITLE_INVALID_USER,
  } from '@/common/util/consent/const'
  import { PATH_NAME_LOGIN } from '@/common/router.const'
  import { useRouterComposable } from '@/common/use/useRouterComposable'
  import { isLogin } from '@/common/util/credential/is-login'
  import { useRoute } from 'vue-router/composables'

  const { checkPopup } = useConsentRenew()
  const { pushRouter } = useRouterComposable()
  const route = useRoute()

  const promotionInfo = ref(null)
  const isLoaded = ref(false)
  const isError = ref(false)
  const loginStatus = ref(false)

  const showPromotionPage = (promotionData) => {
    isError.value = false
    promotionInfo.value = promotionData?.info ?? {}
  }

  const setData = async () => {
    await checkPopup({
      onSuccess: (data) => showPromotionPage(data),
      onInvalid: () => (isError.value = true),
    })
    isLoaded.value = true
  }

  const init = () => {
    loginStatus.value = isLogin()

    if (!loginStatus.value) {
      return pushRouter({
        name: PATH_NAME_LOGIN,
        query: { referer: route?.fullPath },
      })
    }

    setData()
  }

  init()
</script>
